'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextArea = function (_Component) {
  (0, _inherits3.default)(TextArea, _Component);

  function TextArea(props) {
    (0, _classCallCheck3.default)(this, TextArea);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TextArea.__proto__ || (0, _getPrototypeOf2.default)(TextArea)).call(this, props));

    _this.onFocus = function (event) {
      var textarea = _this.props.textarea;

      _this.setState({ visited: true });

      if (textarea && textarea.onFocus) {
        textarea.onFocus(event);
      }
    };

    _this.className = function () {
      var _this$props = _this.props,
          success = _this$props.success,
          warning = _this$props.warning,
          error = _this$props.error,
          parentWidth = _this$props.parentWidth;

      return (0, _classnames2.default)({
        'quiver-text-area': true,
        'quiver-text-area--parent-width': parentWidth,
        'quiver-text-area--visited': _this.state.visited,
        'quiver-text-area--success': success,
        'quiver-text-area--warning': warning,
        'quiver-text-area--error': error
      });
    };

    _this.state = {
      visited: !!props.defaultValue
    };
    return _this;
  }

  (0, _createClass3.default)(TextArea, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          defaultValue = _props.defaultValue,
          label = _props.label,
          textarea = _props.textarea,
          message = _props.message,
          style = _props.style;


      return _react2.default.createElement(
        'div',
        { className: this.className(), style: style },
        _react2.default.createElement(
          'label',
          { htmlFor: id, style: style && style.label },
          label
        ),
        _react2.default.createElement('textarea', (0, _extends3.default)({}, textarea, {
          id: id,
          defaultValue: defaultValue,
          onFocus: this.onFocus,
          style: style && style.textarea
        })),
        message ? _react2.default.createElement(
          'span',
          { className: 'quiver-text-area__message', style: style && style.message },
          message
        ) : null
      );
    }
  }]);
  return TextArea;
}(_react.Component);

TextArea.propTypes = {
  id: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  label: _propTypes2.default.string,
  message: _propTypes2.default.string,
  error: _propTypes2.default.bool,
  touched: _propTypes2.default.bool,
  success: _propTypes2.default.bool,
  warning: _propTypes2.default.bool,
  parentWidth: _propTypes2.default.bool,
  textarea: _propTypes2.default.object,
  style: _propTypes2.default.object
};
exports.default = TextArea;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TextArea/TextArea.js
// module id = 688
// module chunks = 11